// panel-menu-tooltips.js
; (() => {
    const panel = document.querySelector('.panel-menu')
    if (!panel) { return }
    const shownTooltipClass = 'panel-menu__tooltip_shown'
    const triggers = panel.querySelectorAll('.panel-menu__tooltip-trigger')
    const tooltip = panel.querySelector('.panel-menu__tooltip')

    let timerHandle_hideTooltip = null
    const hideTimeout = 400
    let lastTrigger = null

    panel.addEventListener('mouseleave', e => {
        clearTimeout(timerHandle_hideTooltip)
        hideTooltip()
    });

    ['drag-y', 'wheel-y'].forEach(eventName => {
        panel.addEventListener(eventName, () => {
            showTooltip(lastTrigger)
        })
    })

    triggers.forEach(t => {
        t.addEventListener('mouseleave', () => {
            timerHandle_hideTooltip = setTimeout(hideTooltip, hideTimeout)
        })

        t.addEventListener('mouseenter', () => {
            clearTimeout(timerHandle_hideTooltip)
            showTooltip(t)
        })
    })

    function showTooltip(trigger) {
        if (!tooltip || !trigger) {
            hideTooltip()
            return
        }
        lastTrigger = trigger

        const { top: triggerTop, height: triggerHeight }
            = trigger.getBoundingClientRect()

        const tooltipTextEl = trigger.querySelector('.panel-menu__tooltip-text')
        if (!tooltipTextEl) { return }
        const tooltipText = tooltipTextEl.innerHTML.trim()
        tooltip.innerHTML = tooltipText

        const { height: tooltipHeight }
            = tooltip.getBoundingClientRect()

        tooltip.style.top = `${triggerTop + triggerHeight / 2 - tooltipHeight / 2}px`

        tooltip.classList.add(shownTooltipClass)
    }

    function hideTooltip() {
        if (!tooltip) { return }
        tooltip.classList.remove(shownTooltipClass)
        lastTrigger = null
    }
})();